export { CollectResponses } from './CollectResponses';
